import CityServiceTemplate from "@/components/CityServiceTemplate";
import lakehillsHero from "@/assets/cities/lakehills-hero.jpg";

const CarServiceLakehills = () => {
  return (
    <CityServiceTemplate
      cityName="Lakehills"
      cityDescription="Premium black car service connecting Lakehills to San Antonio and beyond. Reliable luxury transportation for residents and visitors in the Texas Hill Country."
      metaDescription="Black car service in Lakehills, TX. Professional chauffeur service to San Antonio, SAT Airport, and surrounding areas. Book your ride today."
      canonicalPath="/lakehills-car-service"
      heroImage={lakehillsHero}
      additionalContent="Lakehills' peaceful Hill Country setting is perfectly complemented by Rick's Black Car Service. We provide residents and guests with premium transportation to San Antonio attractions, medical appointments, SAT Airport, and special events with punctuality and professionalism."
      coordinates={{
        latitude: 29.5991,
        longitude: -98.9367
      }}
      serviceRadius="50 miles"
      featuredPricing={{
        route: "Lakehills ↔ SAT Airport",
        price: "$265",
        note: "All-inclusive flat rate (includes 20% gratuity)"
      }}
      cityReviews={[
        {
          author: "Barbara Johnson",
          rating: 5,
          date: "2024-11-05",
          text: "Living in Lakehills, reliable transportation to San Antonio is essential. Rick provides excellent service - always on time and his vehicle is immaculate. Perfect for our medical appointments downtown."
        },
        {
          author: "George Anderson",
          rating: 5,
          date: "2024-09-30",
          text: "Rick transported our family from Lakehills to SAT Airport for our vacation. Professional, courteous, and made the early morning pickup effortless. Highly recommend!"
        }
      ]}
    />
  );
};

export default CarServiceLakehills;
